<script>
	const model = require('model/model');
	const navKey = 'stepreadsSection';
	module.exports = {
		props: ['article', 'route-context'],

		components: {
			'content-body': require('components/content-body.vue').default
		},
		modelData: ['stepreadsSection', 'whiteboardView'],
		computed: {
			selectedArticle() {
				var article = this.article;
				let articleMap = article && article.articles;
				let articleList = article && article.articleList;

				let selectedArticle = null;

				if (article && articleList) {
					let key = this[navKey];
					selectedArticle = key ? articleMap[key] : articleList[0];
				} else {
					selectedArticle = article;
				}

				return selectedArticle;
			}
		},
		methods: {
			onArticleSelect(pid) {
				model.set(navKey, pid);
			}
		},
		watch: {
			article() {
				let key = model.get(navKey);
				let articleList = this.articleList;
				if (!key && articleList && articleList.length) {
					model.set(navKey, articleList[0].uuid);
				}
			}
		}
	};
</script>
<template>
	<content-body
		:article="article"
		:article-list="article && article.articleList"
		:selected-article="selectedArticle"
		:route-context="routeContext"
		:on-article-select="onArticleSelect"
		:force-highlighting="whiteboardView"
		:step-read="true"></content-body>
</template>
